function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fad201"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v10H0V5Z",
    style: {
      fill: "#00a3e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,20h30v5H0v-5Z",
    style: {
      fill: "#20603d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.615,7l.131,2.239.706-2.129-.453,2.197,1.233-1.874-1.007,2.005,1.676-1.491-1.491,1.676,2.005-1.007-1.874,1.233,2.197-.453-2.129.706,2.239.131-2.239.131,2.129.706-2.197-.453,1.874,1.233-2.005-1.007,1.491,1.676-1.676-1.491,1.007,2.005-1.233-1.874.453,2.197-.706-2.129-.131,2.239-.131-2.239-.706,2.129.453-2.197-1.231,1.87,1.007-2.005-1.676,1.491,1.491-1.676-2.005,1.007,1.874-1.233-2.197.453,2.129-.706-2.239-.131,2.239-.131-2.129-.706,2.197.453-1.874-1.233,2.005,1.007-1.491-1.676,1.676,1.491-1.007-2.001,1.233,1.874-.453-2.197.706,2.129.129-2.239Z",
    style: {
      fill: "#e5be01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.615,11.231c-.551,0-1-.449-1-1s.449-1,1-1,1,.449,1,1-.448,1-1,1ZM24.615,9.346c-.488,0-.885.397-.885.885s.397.885.885.885.885-.397.885-.885-.397-.885-.885-.885Z",
    style: {
      fill: "#00a3e0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRw);
export default __webpack_public_path__ + "static/media/RW.cb5caaacca7fc8f7eda1f8c6d2df02f9.svg";
export { ForwardRef as ReactComponent };